import { render, staticRenderFns } from "./HistoryUnits.vue?vue&type=template&id=2855ee50&"
import script from "./HistoryUnits.vue?vue&type=script&lang=ts&"
export * from "./HistoryUnits.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2855ee50')) {
      api.createRecord('2855ee50', component.options)
    } else {
      api.reload('2855ee50', component.options)
    }
    module.hot.accept("./HistoryUnits.vue?vue&type=template&id=2855ee50&", function () {
      api.rerender('2855ee50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sales/reports/history-unit/HistoryUnits.vue"
export default component.exports